import { useEffect, useRef } from "react";

let scriptPromise = null;

function loadTvScript() {
  if (window.TradingView) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://s3.tradingview.com/tv.js";
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

export default function TradingViewChart({ symbol, theme = "dark", interval = "60", height = "100%" }) {
  const containerRef = useRef(null);
  const idRef = useRef(`tv_${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    let cancelled = false;
    loadTvScript().then(() => {
      if (cancelled || !containerRef.current) return;
      containerRef.current.innerHTML = "";
      new window.TradingView.widget({
        autosize: true,
        symbol,
        interval,
        timezone: "Etc/UTC",
        theme,
        style: "1",
        locale: "en",
        allow_symbol_change: false,
        hide_side_toolbar: false,
        container_id: idRef.current,
      });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [symbol, theme, interval]);

  return (
    <div
      ref={containerRef}
      id={idRef.current}
      data-testid="tradingview-chart"
      style={{ height, width: "100%" }}
    />
  );
}
